import { render, staticRenderFns } from "./StandartsCatalogModule.vue?vue&type=template&id=31e8e15b&"
import script from "./StandartsCatalogModule.vue?vue&type=script&lang=js&"
export * from "./StandartsCatalogModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports